(() => {
  if (window.cbInquiryEventsReady) return;
  window.cbInquiryEventsReady = true;

  const attributionKey = 'cb_rfq_attribution_v2';
  const pendingKey = 'cb_rfq_pending_v2';
  const measuredKey = 'cb_rfq_measured_v2';
  const maxAge = 30 * 60 * 1000;
  const routeValue = (value) => value === 'private' ? 'private' : 'brand';
  const read = (key) => {
    try { return JSON.parse(window.sessionStorage.getItem(key) || 'null'); } catch (_) { return null; }
  };
  const write = (key, value) => {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; }
  };
  const remove = (key) => {
    try { window.sessionStorage.removeItem(key); } catch (_) {}
  };
  const publish = (name, data) => {
    if (window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main') return;
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;
    try { Promise.resolve(window.Shopify.analytics.publish(name, data)).catch(() => {}); } catch (_) {}
  };
  const source = () => ({ page_path: window.location.pathname });
  const shortText = (value, length) => String(value || '').replace(/[\u0000-\u001f\u007f<>]/g, '').trim().slice(0, length);
  const params = new URLSearchParams(window.location.search);
  const currentPage = window.location.origin + window.location.pathname;
  const previous = read(attributionKey);
  const previousValid = previous && typeof previous === 'object' && Date.now() - previous.created_at < 24 * 60 * 60 * 1000;
  const currentCampaign = {};
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign']) {
    const value = shortText(params.get(key), 150);
    if (value && !value.includes('@')) currentCampaign[key] = value;
  }
  const attribution = {
    created_at: previousValid ? previous.created_at : Date.now(),
    landing_page: previousValid && typeof previous.landing_page === 'string' ? previous.landing_page.slice(0, 600) : currentPage,
    campaign: Object.keys(currentCampaign).length ? currentCampaign : previousValid && previous.campaign && typeof previous.campaign === 'object' ? previous.campaign : {}
  };
  write(attributionKey, attribution);

  const pending = () => {
    const value = read(pendingKey);
    if (!value || typeof value.token !== 'string' || typeof value.form_id !== 'string' || typeof value.created_at !== 'number') return null;
    if (Date.now() - value.created_at > maxAge || value.created_at > Date.now()) { remove(pendingKey); return null; }
    return value;
  };
  const applyRoute = (form, value) => {
    const route = routeValue(value);
    const select = form.querySelector('[data-cb-route]');
    if (select) select.value = route;
    form.dataset.cbBuyerRoute = route;
    form.querySelectorAll('[data-cb-route-field]').forEach((field) => {
      const active = field.dataset.cbRouteField === route;
      field.hidden = !active;
      field.querySelectorAll('input, select, textarea').forEach((input) => { input.disabled = !active; });
    });
    const wrapper = form.closest('[data-cb-rfq-wrapper]');
    wrapper?.querySelectorAll('[data-cb-route-title], [data-cb-route-intro], [data-cb-route-terms]').forEach((node) => {
      if (node.dataset[route]) node.textContent = node.dataset[route];
    });
  };
  const setAttribution = (form) => {
    const fields = [
      ['[data-cb-source]', form.dataset.cbSourcePage || currentPage],
      ['[data-cb-landing]', attribution.landing_page],
      ['[data-cb-campaign-source]', attribution.campaign.utm_source],
      ['[data-cb-campaign-medium]', attribution.campaign.utm_medium],
      ['[data-cb-campaign-name]', attribution.campaign.utm_campaign]
    ];
    for (const [selector, value] of fields) {
      const input = form.querySelector(selector);
      if (input) input.value = shortText(value, 600);
    }
  };
  const checkResult = (form) => {
    const success = form.querySelector('[data-cb-form-success]');
    const error = form.querySelector('[data-cb-form-error]');
    const attempt = pending();
    const ownAttempt = attempt?.form_id === form.id;
    if (success && attempt && !ownAttempt) success.hidden = true;
    const notice = error || (success && !success.hidden ? success : null);
    if (notice && !notice.dataset.cbFocused) {
      notice.dataset.cbFocused = 'true';
      notice.focus({ preventScroll: true });
      notice.scrollIntoView({ block: 'center', behavior: 'auto' });
    }
    if (error && !error.dataset.cbMeasured) {
      error.dataset.cbMeasured = 'true';
      publish('cantonbag:rfq_error', { ...source(), buyer_route: form.dataset.cbBuyerRoute });
      if (ownAttempt) remove(pendingKey);
    }
    if (!success || success.dataset.cbMeasured) return;
    success.dataset.cbMeasured = 'true';
    if (!ownAttempt) return;
    const measured = read(measuredKey);
    remove(pendingKey);
    if (measured?.token === attempt.token) return;
    if (!write(measuredKey, { token: attempt.token, created_at: Date.now() })) return;
    publish('cantonbag:rfq_success', { ...source(), buyer_route: routeValue(attempt.buyer_route) });
  };
  const prepare = () => {
    document.querySelectorAll('form[data-cb-inquiry-form]').forEach((form) => {
      if (!form.dataset.cbReady) {
        form.dataset.cbReady = 'true';
        const select = form.querySelector('[data-cb-route]');
        const attempt = pending();
        const hasResult = form.querySelector('[data-cb-form-success], [data-cb-form-error]');
        const resultRoute = hasResult && attempt?.form_id === form.id ? attempt.buyer_route : null;
        if (hasResult && attempt?.form_id === form.id && typeof attempt.source_page === 'string') form.dataset.cbSourcePage = attempt.source_page;
        const requestedRoute = ['brand', 'private'].includes(params.get('route')) ? params.get('route') : null;
        applyRoute(form, resultRoute || requestedRoute || select?.value);
        const style = form.querySelector('[data-cb-style]');
        if (style && !style.value && params.get('style')) style.value = shortText(params.get('style'), 300);
        setAttribution(form);
        select?.addEventListener('change', () => { applyRoute(form, select.value); });
      }
      checkResult(form);
    });
  };

  document.addEventListener('click', (event) => {
    const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!anchor) return;
    if (anchor.hasAttribute('data-cb-privacy-link')) {
      const wrapper = anchor.closest('[data-cb-rfq-wrapper]');
      const details = wrapper?.querySelector('details[id].cb-form__optional');
      if (details) details.open = true;
    }
    let url;
    try { url = new URL(anchor.href, window.location.origin); } catch (_) { return; }
    const placement = anchor.closest('.cb-header') ? 'header' : anchor.closest('[data-cb-rfq-wrapper]') ? 'rfq' : anchor.closest('.cb-product') ? 'product' : 'other';
    const form = anchor.closest('form[data-cb-inquiry-form]') || anchor.closest('[data-cb-rfq-wrapper]')?.querySelector('form[data-cb-inquiry-form]');
    const data = { ...source(), placement };
    if (form?.dataset.cbBuyerRoute) data.buyer_route = form.dataset.cbBuyerRoute;
    if (url.hostname === 'wa.me') publish('cantonbag:whatsapp_click', data);
    if (url.protocol === 'mailto:') publish('cantonbag:email_click', data);
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-cb-inquiry-form]')) return;
    if (!form.checkValidity()) return;
    setAttribution(form);
    const token = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    write(pendingKey, { token, form_id: form.id, buyer_route: routeValue(form.dataset.cbBuyerRoute), source_page: form.dataset.cbSourcePage || currentPage, created_at: Date.now() });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare);
  else prepare();
  document.addEventListener('shopify:section:load', prepare);
})();
